import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as DataDictionaryActions from './data-dictionary.actions';
import { of, switchMap } from 'rxjs';
import { StringUtil } from '@uzurv/core';
import { Router } from '@angular/router';

@Injectable()
export class DataDictionaryEffects {
  constructor(private actions$: Actions, private router: Router) {}

  openDataDictionary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataDictionaryActions.OpenDataDictionary),
      switchMap(action => {
        this.router.navigate([`/data-dictionary/${StringUtil.hashCode(action.title)}`]);
        return of(DataDictionaryActions.OpenDataDictionarySuccess());
      })
    )
  );
}
